export default __webpack_public_path__ + "static/media/missionBox.1966d340.png";